module.exports = __webpack_public_path__ + "img/banner.2a6d8ab2.png";